import styled from 'styled-components';

export const TooltipContent = styled.div`
  padding: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const TooltipTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
`;

export const TooltipSubtitle = styled.div`
  font-size: 12px;
  color: #666;
`; 